import React from 'react';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

if (pdfMake.vfs === undefined) {
  pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts.vfs;
}

// ---------- Design tokens ----------
const COLORS = {
  bg: '#F6F5F1',        // cream / paper
  bgAlt: '#EFEDE6',
  ink: '#111317',        // near black
  ink2: '#3B3F45',
  hairline: '#1113171A', // 10 % ink
  accent: '#F5A800',     // Continental amber
  accentDark: '#B07900',
};

// ---------- Data ----------
const META = {
  client: 'Barum Continental / Barum Czech Rally Zlín',
  eventTitle: 'VIP / hospitality zóna – Barum Czech Rally Zlín',
  eventSubtitle: 'Páteční městská RZ — střecha garáží u 21. budovy',
  date: 'pátek 14. 8. 2026',
  time: '17:30 – 23:30 (příprava do 16:00, noční úklid a odvoz po akci)',
  location: 'Garáže u 21. budovy, Zlín — předposlední a poslední patro',
  capacity: '900 osob',
  validity: 'Nabídka platná do 28. 2. 2026',
  supplier: {
    name: 'Jakub Vodárek (Vseproakci.cz)',
    contact: 'Jakub Vodárek, jednatel',
    phone: '+420 774 750 456',
    email: 'info@vseproakci.cz',
    ico: '74953613',
    dic: 'CZ8805254557',
    address: 'SNP 1187, 765 02 Otrokovice',
  },
};

const SCHEDULE = [
  { time: '08:00 – 11:00', task: 'Nájezd techniky, vykládka mobiliáře, doprava TOI TOI' },
  { time: '09:00 – 13:00', task: 'Instalace TOI TOI (16 ks), osvětlení sanitární zóny, stavební zábrany' },
  { time: '10:00 – 14:00', task: 'Elektroinstalace, rozvody, kabelové trasy a značení; revize a zkušební napájení' },
  { time: '11:00 – 15:00', task: 'Catering setup – výdejní místa, výčepy, chlazení, sklad, výroba na místě' },
  { time: '13:00 – 15:30', task: 'Rozmístění pivních setů (cca 110 ks), zónování ploch, evakuační koridory' },
  { time: '15:00 – 16:00', task: 'Briefing personálu, kontrolní obchůzka, předakční úklid, bezpečnostní obhlídka' },
  { time: '16:00 – 17:30', task: 'Final check – elektro, gastro, ostraha. Příjem klienta, předání zóny.' },
  { time: '17:30 – 23:30', task: 'Otevření zóny pro hosty – provoz cateringu, výčepů, komerční gastro zóny, programu' },
  { time: 'průběžně', task: 'Servis TOI TOI, doplňování zásob, odpadové hospodářství, koordinace ostrahy' },
  { time: '23:30 – 02:00', task: 'Uzavření zóny, závěrečný noční úklid, odvoz odpadu, demontáž výčepů' },
  { time: '02:00 – 06:00', task: 'Odvoz mobiliáře, TOI TOI, techniky a cateringového zázemí — předání plochy' },
];

const CATERING_FREE_FOOD = [
  { item: 'Farmářská klobáska', detail: 'Grilovaná farmářská klobáska, křen, hořčice, kysané zelí, čerstvě upečený chléb' },
  { item: 'Párek v rohlíku', detail: 'Štýrská klobáska ve francouzském rohlíku, výběr dipů — cibulový, pepřový, andaluský, kečup, hořčice' },
  { item: 'Zapékanka', detail: 'Velká zapečená bageta se sýrem, trhaným masem nebo šunkou' },
  { item: 'Řízky s pečivem', detail: 'Smažené řízky podávané s čerstvě upečeným pečivem' },
  { item: 'Gyros v tortille', detail: 'Kuřecí gyros v tortille s ledovým salátem, červenou cibulkou a tzatziki' },
  { item: 'Quesadilla „Achiotte"', detail: 'Tortilla plněná trhaným vepřovým masem, čedarem, goudou a chimichurri salsou, podávaná se zakysanou smetanou a guacamole' },
  { item: 'Pečené kuřecí paličky', detail: 'BBQ kuřecí paličky se salátem coleslaw a čerstvě upečeným chlebem' },
  { item: 'Vlčnovské koláčky', detail: 'Tradiční moravské koláčky — mix příchutí' },
  { item: 'Valašské frgály', detail: 'Tradiční valašské frgály — tvarohové, makové a hruškové' },
];

const CATERING_FREE_DRINKS = [
  { item: 'Pivo', detail: 'Radegast 10' },
  { item: 'Nealko pivo', detail: 'Birell / Birell pomelo & grep' },
  { item: 'Limonáda', detail: 'Malinová' },
  { item: 'Prosecco', detail: 'Čepované, plastové sklenice' },
];

const CATERING_PAID = [
  { item: 'Tvrdý alkohol', detail: 'Whisky, gin, rum — kvalitní brands' },
  { item: 'Koktejly', detail: 'Mixology bar — premium koktejly, longdrinky, gin & tonic' },
];

const ENTRANCE_PROCESS = [
  'Výroba identifikačních náramků / vstupenek (varianta s logem Barum)',
  '2 brigádníci pro distribuci vstupenek zaměstnancům v týdnu před akcí',
  'Evidence rezervací v Excel / sdíleném dashboardu (jméno + počet vstupů)',
  'On-site validace u vstupu — kontrola náramku, evidence vstupů, zamezení duplicit',
];

const REFERENCES = [
  {
    title: 'eBF — eBiz Forum 2026',
    tag: '22. ročník · F&B Partner · Procurement Festival',
    description:
      'Kompletní gastronomické zajištění největšího evropského festivalu o firemním nákupu a veřejných zakázkách. Dolní oblast Vítkovice, Ostrava.',
    stats: '3 dny · 1 000+ účastníků · 165 přednášejících · 10 sálů',
    client: 'eBF / Procurement Festival',
    date: '19.–21. 5. 2026',
    insight: 'Nejvyšší standard F&B servisu pro flagship evropský B2B festival.',
  },
  {
    title: 'Pulse Konference 2025',
    tag: 'Konference · Catering',
    description:
      'Komplexní cateringový servis: coffee breaky, rautový servis, nápojové stanice a obsluha během dvoudenní odborné konference v Gongu.',
    stats: '1 000+ osob / den',
    client: 'New Look Media s.r.o.',
    date: '05/2025',
    insight: 'Přímá zkušenost s konferenčním formátem srovnatelným s eBF.',
  },
  {
    title: 'WTA 250 – Ostravar Open',
    tag: 'Mezinárodní sport · VIP',
    description:
      'Players Room a VIP Area během mezinárodního tenisového turnaje. Kompletní gastronomický servis pro VIP hosty a organizační tým.',
    stats: '3 500 hostů / 7 dní',
    client: 'PERINVEST s.r.o.',
    date: '2026',
    insight: 'Kontinuální VIP servis na mezinárodní sportovní akci.',
  },
  {
    title: 'OKTAGON 61 – Brno',
    tag: 'Sport · Galavečer',
    description:
      'Kompletní gastronomický servis pro VIP i veřejné zóny během mezinárodního sportovního galavečera.',
    stats: '600 hostů',
    client: '2NP production s.r.o.',
    date: '09/2024',
    insight: 'VIP i mass-market segment v rámci jedné akce.',
  },
  {
    title: '120 let Bochemie',
    tag: 'Firemní gala · ALL INCLUSIVE',
    description:
      'Reprezentativní firemní výroční akce vysoké úrovně včetně kompletního personálního a technického zajištění.',
    stats: '400 hostů',
    client: 'BOCHEMIE a.s.',
    date: '09/2024',
    insight: 'Referenční zakázka pro nadnárodní korporát.',
  },
  {
    title: 'Jasno — 35 let',
    tag: 'Firemní výročí · Catering',
    description:
      'Catering pro 1 500 osob realizovaný v rámci firemních prostor společnosti Jasno.',
    stats: '1 500 hostů',
    client: 'Jasno',
    date: '15. 5. 2026',
    insight: 'Velkokapacitní catering v in-house firemním prostředí.',
  },
  {
    title: '90 let Fatra Napajedla',
    tag: 'Firemní výročí · Gastro · Technika',
    description:
      'Kompletní realizace oslav světového dodavatele plastových výrobků. Gastronomie, technika, program.',
    stats: '3 500 hostů',
    client: 'FATRA, a.s.',
    date: '06/2024',
    insight: 'Referenční zakázka pro korporátní výročí.',
  },
];

// ---------- Pricing ----------
const PRICING_GROUPS = [
  {
    label: '01 — Mobiliář',
    items: [
      { name: 'Pivní set (stůl + 2 lavice) vč. dopravy, rozmístění a svozu', qty: 110, unit: 'ks', unitPrice: 200 },
      { name: 'Manipulační tým pro rozmístění a finální svoz', qty: 1, unit: 'paušál', unitPrice: 9000 },
    ],
  },
  {
    label: '02 — Hygienické zázemí (TOI TOI)',
    items: [
      { name: 'TOI TOI — spodní patro (pro Barum Czech Rally)', qty: 6, unit: 'ks', unitPrice: 2000 },
      { name: 'TOI TOI — horní patro', qty: 10, unit: 'ks', unitPrice: 2000 },
      { name: 'Pravidelný servis a obsluha hygienické zóny po dobu akce', qty: 1, unit: 'paušál', unitPrice: 8000 },
      { name: 'Průběžný úklid TOI TOI včetně stálého personálu', qty: 1, unit: 'paušál', unitPrice: 6000 },
      { name: 'Úklid prostor v patrech před akcí i po akci a u TOI TOI', qty: 1, unit: 'paušál', unitPrice: 8000 },
      { name: 'Stavební zábrany k TOI TOI', qty: 1, unit: 'paušál', unitPrice: 4000 },
      { name: 'Závěrečný noční úklid hygienické zóny', qty: 1, unit: 'paušál', unitPrice: 4000 },
    ],
  },
  {
    label: '03 — Catering (základní program zdarma pro hosty)',
    items: [
      { name: 'Food cost — kompletní jídelní a nápojový program pro 900 osob (vč. výdejních míst, výčepů, chlazení, gastro logistiky a odpadového hospodářství)', qty: 900, unit: 'osob', unitPrice: 700 },
    ],
  },
  {
    label: '04 — Technické zajištění (elektro, ozvučení, osvětlení)',
    items: [
      { name: 'Elektro rozvody, kabelové trasy, revize, značení', qty: 1, unit: 'paušál', unitPrice: 10000 },
      { name: 'Osvětlení gastro / VIP zóny, atmosférické osvětlení střechy', qty: 1, unit: 'paušál', unitPrice: 14000 },
      { name: 'Ozvučení (PA systém, mikrofony, propojení s programem RZ)', qty: 1, unit: 'paušál', unitPrice: 13000 },
      { name: 'Technický dozor po dobu akce (revizní technik, kabeláž)', qty: 1, unit: 'paušál', unitPrice: 9000 },
    ],
  },
  {
    label: '05 — Bezpečnost a ostraha',
    items: [
      { name: 'Security — 8 členů (kontrola vstupů, dohled nad zónami, koordinace evakuace)', qty: 8, unit: 'osoba × 8 h', unitPrice: 3200 },
      { name: 'Noční ostraha se psem (uzavření zóny, odvoz techniky)', qty: 1, unit: 'paušál', unitPrice: 7000 },
      { name: 'Koordinace bezpečnosti, briefing, komunikace s pořadatelem RZ', qty: 1, unit: 'paušál', unitPrice: 6000 },
    ],
  },
  {
    label: '06 — Úklid a odpadové hospodářství',
    items: [
      { name: 'Předakční úklid plochy a obou pater garáží', qty: 1, unit: 'paušál', unitPrice: 6000 },
      { name: 'Průběžný úklid během akce (mobilní úklidový tým)', qty: 1, unit: 'paušál', unitPrice: 12000 },
      { name: 'Noční finální úklid (po skončení akce, hluboký úklid)', qty: 1, unit: 'paušál', unitPrice: 14000 },
      { name: 'Komunální odpad — kontejnery, třídění, odvoz', qty: 1, unit: 'paušál', unitPrice: 9000 },
    ],
  },
  {
    label: '07 — Vstupy a evidence',
    items: [
      { name: 'Výroba identifikačních náramků s logem Barum', qty: 900, unit: 'ks', unitPrice: 9 },
      { name: 'Distribuce vstupenek zaměstnancům – 2 brigádníci', qty: 2, unit: 'osoba × 8 h', unitPrice: 2400 },
      { name: 'Evidence rezervací, on-site validace u vstupu', qty: 1, unit: 'paušál', unitPrice: 6000 },
    ],
  },
  {
    label: '08 — Produkce a koordinace',
    items: [
      { name: 'Projektový manažer (předprodukce + den akce + reporting)', qty: 1, unit: 'paušál', unitPrice: 28000 },
      { name: 'Koordinátor cateringu a personálu na místě', qty: 1, unit: 'paušál', unitPrice: 12000 },
      { name: 'Předakční obhlídky, jednání s pořadatelem a městem', qty: 1, unit: 'paušál', unitPrice: 8000 },
    ],
  },
];

const fmt = (v) => Math.round(v).toLocaleString('cs-CZ') + ' Kč';
const fmt2 = (v) => (Math.round(v * 100) / 100).toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Kč';

const calcGroupTotal = (g) => g.items.reduce((s, it) => s + it.qty * it.unitPrice, 0);
const SUBTOTAL_NO_VAT = PRICING_GROUPS.reduce((s, g) => s + calcGroupTotal(g), 0);

// Ticket revenue — návštěvníci (zaměstnanci klienta) si platí vstup, klient prodává vstupenky 400 Kč vč. DPH.
// Vstupné na sportovní/kulturní akce má sníženou sazbu DPH 12 %.
// Pro odpočet z kalkulace bez DPH používáme net hodnotu při sazbě 12 %.
const GUEST_COUNT = 900;
const TICKET_PRICE = 400;                 // gross (vč. DPH 12 %)
const TICKET_VAT_RATE = 0.12;             // snížená sazba DPH pro vstupné
const VAT_RATE = 0.21;                    // dominantní sazba pro služby/produkci
const TICKET_PRICE_NET = TICKET_PRICE / (1 + TICKET_VAT_RATE); // 357,14 Kč bez DPH
const TICKET_REVENUE_GROSS = GUEST_COUNT * TICKET_PRICE;     // vč. DPH
const TICKET_REVENUE = Math.round(GUEST_COUNT * TICKET_PRICE_NET); // bez DPH — pro odpočet

// Finální obchodní sleva — partnerský benefit, kompletní zakázka.
const FINAL_DISCOUNT = 20000;

const TOTAL_NO_VAT = SUBTOTAL_NO_VAT - TICKET_REVENUE - FINAL_DISCOUNT;
const TOTAL_WITH_VAT = TOTAL_NO_VAT * (1 + VAT_RATE);

// ---------- Building blocks ----------
const SectionLabel = ({ number, title }) => (
  <div className="mb-8">
    <div
      className="text-xs tracking-[0.3em] font-medium mb-2"
      style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}
    >
      {number}
    </div>
    <h2
      className="text-3xl md:text-4xl font-semibold leading-tight"
      style={{ color: COLORS.ink, fontFamily: "'Source Serif Pro', 'Playfair Display', Georgia, serif", letterSpacing: '-0.01em' }}
    >
      {title}
    </h2>
    <div className="mt-4 h-px w-16" style={{ background: COLORS.accent }} />
  </div>
);

const Para = ({ children }) => (
  <p
    className="text-base md:text-[17px] leading-relaxed mb-4"
    style={{ color: COLORS.ink2, fontFamily: "'Inter', system-ui, sans-serif" }}
  >
    {children}
  </p>
);

const KeyValueRow = ({ k, v, accent = false }) => (
  <div
    className="flex items-baseline justify-between py-3 border-b"
    style={{ borderColor: COLORS.hairline }}
  >
    <span
      className="text-xs uppercase tracking-wider"
      style={{ color: COLORS.ink2, fontFamily: "'Inter', system-ui, sans-serif", letterSpacing: '0.12em' }}
    >
      {k}
    </span>
    <span
      className={accent ? 'text-base font-semibold' : 'text-base'}
      style={{ color: accent ? COLORS.accentDark : COLORS.ink, fontFamily: "'Inter', system-ui, sans-serif" }}
    >
      {v}
    </span>
  </div>
);

const BulletList = ({ items }) => (
  <ul className="space-y-2 mb-4" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
    {items.map((it, i) => (
      <li key={i} className="flex items-start text-[15px]" style={{ color: COLORS.ink2 }}>
        <span
          className="mr-3 mt-2.5 inline-block w-2 h-px shrink-0"
          style={{ background: COLORS.accent }}
        />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

const SectionReferences = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bg }} data-testid="references-section">
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <div>
          <div
            className="text-xs tracking-[0.3em] font-medium mb-2"
            style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}
          >
            R
          </div>
          <h2
            className="text-3xl md:text-4xl font-semibold leading-tight"
            style={{ color: COLORS.ink, fontFamily: "'Source Serif Pro', 'Playfair Display', Georgia, serif", letterSpacing: '-0.01em' }}
          >
            Reference
          </h2>
          <div className="mt-4 h-px w-16" style={{ background: COLORS.accent }} />
        </div>
        <div>
          <Para>
            Výběr nedávných referencí relevantních pro typ a kapacitu akce Barum
            Czech Rally Zlín — konferenční formáty, sportovní eventy s VIP servisem
            a firemní galavečery pro nadnárodní korporáty.
          </Para>

          <div className="grid md:grid-cols-2 gap-5 mt-8">
            {REFERENCES.map((r) => (
              <article
                key={r.title}
                className="bg-white p-6 flex flex-col"
                style={{ borderTop: `2px solid ${COLORS.accent}` }}
              >
                <div
                  className="text-[10px] tracking-[0.25em] uppercase mb-3"
                  style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}
                >
                  {r.tag}
                </div>
                <h3
                  className="text-xl md:text-[22px] font-semibold leading-snug mb-3"
                  style={{ color: COLORS.ink, fontFamily: "'Source Serif Pro', Georgia, serif" }}
                >
                  {r.title}
                </h3>
                <p
                  className="text-[14px] leading-relaxed mb-4 flex-grow"
                  style={{ color: COLORS.ink2, fontFamily: "'Inter', system-ui, sans-serif" }}
                >
                  {r.description}
                </p>

                <div
                  className="grid grid-cols-3 gap-3 pt-4 mt-auto"
                  style={{ borderTop: `1px solid ${COLORS.hairline}`, fontFamily: "'Inter', system-ui, sans-serif" }}
                >
                  <div>
                    <div className="text-[10px] tracking-[0.2em] uppercase mb-1" style={{ color: COLORS.accentDark }}>
                      Rozsah
                    </div>
                    <div className="text-[13px] font-medium" style={{ color: COLORS.ink }}>
                      {r.stats}
                    </div>
                  </div>
                  <div>
                    <div className="text-[10px] tracking-[0.2em] uppercase mb-1" style={{ color: COLORS.accentDark }}>
                      Klient
                    </div>
                    <div className="text-[13px] font-medium" style={{ color: COLORS.ink }}>
                      {r.client}
                    </div>
                  </div>
                  <div>
                    <div className="text-[10px] tracking-[0.2em] uppercase mb-1" style={{ color: COLORS.accentDark }}>
                      Realizace
                    </div>
                    <div className="text-[13px] font-medium" style={{ color: COLORS.ink }}>
                      {r.date}
                    </div>
                  </div>
                </div>

                <p
                  className="mt-4 pt-3 text-[12px] italic"
                  style={{ color: COLORS.ink2, borderTop: `1px solid ${COLORS.hairline}`, fontFamily: "'Inter', system-ui, sans-serif" }}
                >
                  → {r.insight}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

// ---------- Sections ----------
const Hero = () => (
  <header
    className="relative overflow-hidden"
    style={{ background: COLORS.ink, color: '#F6F5F1' }}
  >
    <div
      className="absolute inset-0 opacity-[0.06]"
      style={{
        backgroundImage: `linear-gradient(${COLORS.accent}33 1px, transparent 1px), linear-gradient(90deg, ${COLORS.accent}33 1px, transparent 1px)`,
        backgroundSize: '64px 64px',
      }}
    />
    <div className="relative max-w-6xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
      <div
        className="text-xs tracking-[0.4em] mb-8"
        style={{ color: COLORS.accent, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}
        data-testid="barum-hero-label"
      >
        OBCHODNÍ NABÍDKA — EVENT PRODUCTION
      </div>

      <h1
        className="text-4xl md:text-6xl lg:text-7xl font-semibold leading-[1.05] mb-6 max-w-4xl"
        style={{ fontFamily: "'Source Serif Pro', 'Playfair Display', Georgia, serif", letterSpacing: '-0.02em' }}
      >
        VIP / Hospitality zóna
        <br />
        Barum Czech Rally Zlín
      </h1>

      <p
        className="text-lg md:text-xl max-w-2xl mb-12"
        style={{ color: '#D9D7CF', fontFamily: "'Inter', system-ui, sans-serif" }}
      >
        Technicko-organizační návrh komplexního zajištění páteční městské RZ
        na střeše garáží u 21. budovy. Pro Barum Continental, ročník 2026.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 max-w-4xl pt-8 border-t" style={{ borderColor: '#FFFFFF1A' }}>
        {[
          { k: 'KLIENT', v: 'Barum Continental' },
          { k: 'TERMÍN', v: '14. 8. 2026' },
          { k: 'KAPACITA', v: '900 osob' },
          { k: 'PROVOZ', v: '17:30 – 23:30' },
        ].map((b) => (
          <div key={b.k}>
            <div
              className="text-[10px] tracking-[0.3em] mb-2"
              style={{ color: COLORS.accent, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}
            >
              {b.k}
            </div>
            <div className="text-base md:text-lg font-medium" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
              {b.v}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-14 flex flex-wrap items-center gap-6 text-sm" style={{ color: '#A8A69E', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>
        <span>DOKUMENT č. BCR/2026/HOSP-21</span>
        <span style={{ color: '#FFFFFF33' }}>|</span>
        <span>Verze 1.0 — Otrokovice</span>
      </div>
    </div>
  </header>
);

const SectionIntro = () => (
  <section id="intro" className="py-20 md:py-28" style={{ background: COLORS.bg }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="01" title="Úvod" />
        <div>
          <Para>
            Děkujeme za příležitost ucházet se o realizaci VIP a hospitality zóny pro
            Barum Czech Rally Zlín 2026. Předkládáme komplexní technicko-organizační
            nabídku pokrývající kompletní zajištění páteční městské rychlostní zkoušky
            na střeše garáží u 21. budovy.
          </Para>
          <Para>
            Naše agentura má zkušenost s realizací firemních eventů pro 200 – 3 500 hostů,
            včetně náročných venkovních a víceúrovňových lokací. Nabídka je strukturována
            tak, aby pokrývala všechny aspekty produkce — od logistiky a techniky přes
            catering, mobiliář a hygienické zázemí až po bezpečnost a vstupový systém.
          </Para>
          <Para>
            Cenová úroveň odpovídá náročnosti akce, kapacitě 900 hostů a kvalitativnímu
            standardu očekávanému od značky Continental. Dokument je zároveň koncipován
            jako základ pro dlouhodobou spolupráci v letech 2026 – 2028.
          </Para>
        </div>
      </div>
    </div>
  </section>
);

const SectionUnderstanding = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bgAlt }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="02" title="Pochopení zadání" />
        <div>
          <Para>
            Cílem je vytvoření exkluzivního diváckého a hospitality prostoru pro klienta
            a jeho VIP hosty během páteční městské rychlostní zkoušky. Lokace je
            specifická — dvě patra střechy garážového objektu — což klade vyšší nároky
            na logistiku, bezpečnost evakuačních cest a technickou připravenost.
          </Para>
          <Para>
            Akce probíhá v podvečerních a večerních hodinách, což znamená nutnost dokončit
            kompletní instalaci do 16:00 a po skončení provést bezpečný noční úklid s
            kompletním odvozem techniky tak, aby ráno byl prostor plně předaný správci objektu.
          </Para>

          <div className="grid md:grid-cols-2 gap-6 mt-8">
            <div className="p-6 bg-white" style={{ borderLeft: `3px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: COLORS.accentDark }}>
                Klíčové specifika
              </div>
              <BulletList items={[
                'Dvě patra (předposlední a poslední), vertikální logistika',
                'Hosté přicházejí kontinuálně – nutno řešit tok davu',
                '900 osob bez kapacitních rezerv na chybu',
                'Práce v nočních hodinách (úklid, demontáž)',
              ]} />
            </div>
            <div className="p-6 bg-white" style={{ borderLeft: `3px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: COLORS.accentDark }}>
                Naše odpovědnost
              </div>
              <BulletList items={[
                'Plný projektový management end-to-end',
                'Koordinace s pořadatelem RZ a městem Zlín',
                'Bezpečnost hostů a respekt k brandu Barum',
                'Předání plochy po akci ve stavu před převzetím',
              ]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionScope = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bg }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="03" title="Rozsah služeb" />
        <div>
          <Para>
            Nabídka pokrývá kompletní dodávku služeb v režimu „end-to-end“. Klient
            nepotřebuje pro realizaci samostatně řešit žádné z níže uvedených oblastí —
            vše je zajištěno v rámci jednoho dodavatelského vztahu.
          </Para>
          <div className="grid sm:grid-cols-2 gap-x-12 gap-y-3 mt-8 text-[15px]" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
            {[
              'Projektový management a koordinace',
              'Logistika a doprava',
              'Mobiliář (pivní sety, layout zóny)',
              'Hygienické zázemí (TOI TOI)',
              'Catering – základní program zdarma',
              'Komerční gastro zóna (samostatná ekonomika)',
              'Elektro, ozvučení, osvětlení',
              'Bezpečnost a ostraha',
              'Předakční, průběžný a noční úklid',
              'Vstupový systém a evidence',
              'Odpadové hospodářství',
              'Závěrečné předání plochy',
            ].map((s, i) => (
              <div key={i} className="flex items-baseline" style={{ color: COLORS.ink }}>
                <span
                  className="text-[11px] tracking-[0.2em] mr-3"
                  style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}
                >
                  {String(i + 1).padStart(2, '0')}
                </span>
                {s}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionLogistics = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bgAlt }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="04" title="Logistika a dostupnost" />
        <div>
          <Para>
            Vzhledem ke specifické lokaci (vyvýšená střecha garážového objektu, dvě
            patra) vyžaduje akce přesné fázování dodávek, omezený počet vozidel
            v jeden moment a koordinaci s pořadatelem rally a městskou policií.
          </Para>
          <BulletList items={[
            'Předakční obhlídka (technická + cestovní) – min. 2 návštěvy před akcí',
            'Plán nájezdů techniky rozdělený do 4 časových slotů (kapacita parkoviště)',
            'Jednotná logistická koordinace přes vedoucího produkce',
          ]} />
        </div>
      </div>
    </div>
  </section>
);

const SectionSchedule = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bg }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="05" title="Harmonogram dne" />
        <div>
          <Para>
            Akce probíhá v jednom dni — pátek 14. 8. 2026. Příprava začíná v ranních
            hodinách, hosté přicházejí od 17:30, kompletní úklid a odvoz techniky končí
            do 6:00 ráno následujícího dne.
          </Para>

          <div className="bg-white overflow-hidden mt-6" data-testid="schedule-table">
            <table className="w-full" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
              <thead>
                <tr style={{ background: COLORS.ink, color: '#F6F5F1' }}>
                  <th className="text-left px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium">Čas</th>
                  <th className="text-left px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium">Aktivita</th>
                </tr>
              </thead>
              <tbody>
                {SCHEDULE.map((row, i) => (
                  <tr key={i} style={{ borderTop: `1px solid ${COLORS.hairline}` }}>
                    <td className="px-5 py-4 text-sm font-medium align-top whitespace-nowrap" style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>
                      {row.time}
                    </td>
                    <td className="px-5 py-4 text-[15px]" style={{ color: COLORS.ink2 }}>
                      {row.task}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionTechnical = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bgAlt }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="06" title="Technické zajištění" />
        <div>
          <Para>
            Kompletní technologická vrstva — energetika, kabeláž, ozvučení a osvětlení.
            Veškerá řešení jsou navržena s ohledem na bezpečnostní normy ČSN, redundantní
            napájení a venkovní provoz v případě nepříznivého počasí.
          </Para>
          <div className="grid md:grid-cols-2 gap-4 mt-6">
            {[
              { h: 'Elektro rozvody', items: ['Hlavní rozvaděč + 6 podružných', 'Kabeláž s mechanickou ochranou', 'Kompletní revize a značení', 'Stavební zábrany kabelových tras'] },
              { h: 'Záložní napájení', items: ['UPS jednotka pro citlivá zařízení', 'Motorgenerátor v záloze (silent diesel)', 'Plynulé přepnutí v případě výpadku'] },
              { h: 'Osvětlení', items: ['LED dekorativní osvětlení gastro zóny', 'Funkční osvětlení výdejních míst', 'Bezpečnostní nouzové osvětlení', 'Atmosférická scéna na celé střeše'] },
              { h: 'Ozvučení', items: ['PA systém pro 900 osob, distribuované zóny', 'Bezdrátové mikrofony pro klienta', 'Připojení signálu z RZ (komentátor)', 'Limit hladiny dle hygienických norem'] },
            ].map((b) => (
              <div key={b.h} className="bg-white p-6">
                <div className="text-xs tracking-[0.2em] uppercase mb-3" style={{ color: COLORS.accentDark }}>
                  {b.h}
                </div>
                <BulletList items={b.items} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionCatering = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bg }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="07" title="Catering" />
        <div>
          <Para>
            Catering je rozdělen do dvou vrstev: <strong>základní program zdarma</strong> pro
            všechny hosty (hrazený klientem) — kompletní jídelní a nápojový mix —
            a <strong>komerční bar s lihovinami a koktejly</strong>, který si platí přímo host.
            Tato struktura vyvažuje pohostinnost značky a finanční efektivitu nabídky.
          </Para>

          <div className="mt-8 mb-4 flex items-baseline justify-between">
            <h3 className="text-xl font-semibold" style={{ color: COLORS.ink, fontFamily: "'Source Serif Pro', Georgia, serif" }}>
              Základní program — zdarma pro hosty
            </h3>
            <span className="text-xs tracking-[0.2em]" style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, monospace' }}>
              HRAZENO KLIENTEM
            </span>
          </div>

          <div className="text-[10px] tracking-[0.25em] uppercase mt-2 mb-3" style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, monospace' }}>
            Jídelní nabídka
          </div>
          <div className="bg-white">
            <table className="w-full" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
              <tbody>
                {CATERING_FREE_FOOD.map((c, i) => (
                  <tr key={i} style={{ borderTop: i === 0 ? 'none' : `1px solid ${COLORS.hairline}` }}>
                    <td className="px-5 py-3 text-[15px] font-medium w-1/3" style={{ color: COLORS.ink }}>{c.item}</td>
                    <td className="px-5 py-3 text-[14px]" style={{ color: COLORS.ink2 }}>{c.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-[10px] tracking-[0.25em] uppercase mt-8 mb-3" style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, monospace' }}>
            Nápoje — čepované
          </div>
          <div className="bg-white">
            <table className="w-full" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
              <tbody>
                {CATERING_FREE_DRINKS.map((c, i) => (
                  <tr key={i} style={{ borderTop: i === 0 ? 'none' : `1px solid ${COLORS.hairline}` }}>
                    <td className="px-5 py-3 text-[15px] font-medium w-1/3" style={{ color: COLORS.ink }}>{c.item}</td>
                    <td className="px-5 py-3 text-[14px]" style={{ color: COLORS.ink2 }}>{c.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-8 mb-12">
            <KeyValueBox k="Výdejní místa" v="4× výdejní stanice" />
            <KeyValueBox k="Výčepy" v="4× (pivo / nealko / prosecco)" />
            <KeyValueBox k="Personál cateringu" v="22 osob (kuchaři, výdej, výčep)" />
            <KeyValueBox k="Gastro logistika" v="Sklad + chlazení + 24h dovoz" />
            <KeyValueBox k="Chlazení" v="2× mrazicí box + 4× chladící" />
            <KeyValueBox k="Odpady" v="Třídění + ekologická likvidace" />
          </div>

          <div className="mt-8 mb-4 flex items-baseline justify-between">
            <h3 className="text-xl font-semibold" style={{ color: COLORS.ink, fontFamily: "'Source Serif Pro', Georgia, serif" }}>
              Komerční bar — lihoviny a koktejly
            </h3>
            <span className="text-xs tracking-[0.2em]" style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, monospace' }}>
              SAMOSTATNÁ EKONOMIKA
            </span>
          </div>
          <div className="bg-white">
            <table className="w-full" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
              <tbody>
                {CATERING_PAID.map((c, i) => (
                  <tr key={i} style={{ borderTop: i === 0 ? 'none' : `1px solid ${COLORS.hairline}` }}>
                    <td className="px-5 py-3 text-[15px] font-medium w-1/3" style={{ color: COLORS.ink }}>{c.item}</td>
                    <td className="px-5 py-3 text-[14px]" style={{ color: COLORS.ink2 }}>{c.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-[13px] italic mt-4" style={{ color: COLORS.ink2 }}>
            Komerční bar provozujeme ve vlastní režii — výnos z prodeje lihovin a koktejlů
            není součástí faktury klientovi. Brand klienta je viditelně přítomen
            (značení, servírovací prvky).
          </p>
        </div>
      </div>
    </div>
  </section>
);

const KeyValueBox = ({ k, v }) => (
  <div className="p-5 bg-white" style={{ borderTop: `2px solid ${COLORS.accent}` }}>
    <div className="text-[10px] tracking-[0.25em] uppercase mb-2" style={{ color: COLORS.accentDark, fontFamily: 'ui-monospace, monospace' }}>
      {k}
    </div>
    <div className="text-base font-medium" style={{ color: COLORS.ink, fontFamily: "'Inter', system-ui, sans-serif" }}>
      {v}
    </div>
  </div>
);

const SectionMobiliar = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bgAlt }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="08" title="Mobiliář" />
        <div>
          <Para>
            Pivní sety jsou vhodnou volbou pro tento typ akce — kombinují vysokou
            kapacitu, rychlou instalaci a kulturní fit s prostředím rally. Cena
            <strong> 200 Kč / ks zahrnuje dopravu, rozmístění a následný svoz.</strong>
          </Para>
          <div className="grid md:grid-cols-3 gap-6 mt-6">
            <KeyValueBox k="Počet setů" v="cca 110 ks" />
            <KeyValueBox k="Kapacita" v="~880 míst k sezení" />
            <KeyValueBox k="Layout" v="Distribuováno na obě patra" />
            <KeyValueBox k="Manipulace" v="6 osob — instalace + svoz" />
            <KeyValueBox k="Cena za set" v="200 Kč včetně D + I + S" />
            <KeyValueBox k="Doplňkové prvky" v="Koktejlové stoly v premium zóně" />
          </div>
          <Para>
            Konečný počet setů upřesníme po obhlídce — záleží na finálním zónování,
            evakuačních koridorech a pozici premium baru. Předpokládáme rezervu 5 – 10 setů.
          </Para>
        </div>
      </div>
    </div>
  </section>
);

const SectionToiToi = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bg }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="09" title="Hygienické zázemí (TOI TOI)" />
        <div>
          <Para>
            Sanitární zázemí je dimenzováno přesně podle požadavku — celkem 16 jednotek
            rozdělených mezi obě patra. Cena 2 000 Kč za jednotku zahrnuje pronájem,
            dopravu, instalaci a likvidaci. Kromě toho zajišťujeme kompletní obslužnou vrstvu.
          </Para>
          <div className="grid md:grid-cols-2 gap-6 mt-6">
            <div className="p-6 bg-white" style={{ borderTop: `2px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-3" style={{ color: COLORS.accentDark }}>
                Spodní patro
              </div>
              <div className="text-3xl font-semibold mb-1" style={{ color: COLORS.ink, fontFamily: "'Source Serif Pro', serif" }}>6 ks</div>
              <div className="text-sm" style={{ color: COLORS.ink2 }}>2 000 Kč / ks</div>
            </div>
            <div className="p-6 bg-white" style={{ borderTop: `2px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-3" style={{ color: COLORS.accentDark }}>
                Horní patro
              </div>
              <div className="text-3xl font-semibold mb-1" style={{ color: COLORS.ink, fontFamily: "'Source Serif Pro', serif" }}>10 ks</div>
              <div className="text-sm" style={{ color: COLORS.ink2 }}>2 000 Kč / ks</div>
            </div>
          </div>
          <Para>
            Součástí dodávky je dále:
          </Para>
          <BulletList items={[
            'Pravidelný servis během akce (doplnění hygienických potřeb, kontrola)',
            'Stálá obsluha hygienické zóny — 2 osoby ve směně',
            'Průběžný úklid a hygienická kontrola',
            'Lokální osvětlení zóny (LED, bezpečnostní)',
            'Stavební zábrany a směrové značení',
            'Závěrečný noční úklid sanitárních prostorů',
          ]} />
        </div>
      </div>
    </div>
  </section>
);

const SectionSecurity = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bgAlt }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="10" title="Bezpečnost a ostraha" />
        <div>
          <Para>
            Bezpečnost je zajištěna licencovanou ostrahou s eventovými zkušenostmi.
            Konfigurace zohledňuje dvoupatrovou strukturu, kontinuální průtok hostů
            a nutnost večerního a nočního dohledu.
          </Para>
          <div className="grid md:grid-cols-3 gap-6 mt-6">
            <KeyValueBox k="Security tým" v="8 osob × 8 hodin" />
            <KeyValueBox k="Noční ostraha" v="1 osoba + pes" />
            <KeyValueBox k="Vedoucí směny" v="1 osoba — koordinace" />
            <KeyValueBox k="Kontrola vstupů" v="2 stanice (oba vchody)" />
            <KeyValueBox k="Dohled gastro" v="Premium zóna + výčepy" />
            <KeyValueBox k="Evakuace" v="Označené trasy, briefing" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionPersonnel = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bg }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="11" title="Personální zajištění" />
        <div>
          <Para>
            Akce vyžaduje cca <strong>54 členů personálu</strong> v různých rolích.
            Celý tým je řízen jedním projektovým manažerem a koordinátorem cateringu.
          </Para>
          <div className="bg-white mt-6">
            <table className="w-full" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
              <thead>
                <tr style={{ background: COLORS.ink, color: '#F6F5F1' }}>
                  <th className="text-left px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium">Role</th>
                  <th className="text-right px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium">Počet</th>
                  <th className="text-right px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium">Provoz</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['Projektový manažer', 1, 'celý den'],
                  ['Koordinátor cateringu', 1, 'celý den'],
                  ['Kuchaři + live cooking', 6, '12 hod'],
                  ['Výdejní personál (catering)', 12, '8 hod'],
                  ['Výčepní (4 výčepy)', 8, '8 hod'],
                  ['Pomocný personál + sklad', 4, '10 hod'],
                  ['Premium bar (mixology)', 3, '6 hod'],
                  ['Manipulační tým — mobiliář', 6, 'instalace + svoz'],
                  ['Technický dozor', 1, 'celý den'],
                  ['Ostraha (security)', 8, '8 hod'],
                  ['Noční ostraha (s psem)', 1, 'po skončení'],
                  ['Distribuce vstupenek', 2, 'předakční týden'],
                  ['Úklidový tým', 4, 'průběžně + noc'],
                ].map((r, i) => (
                  <tr key={i} style={{ borderTop: i === 0 ? 'none' : `1px solid ${COLORS.hairline}` }}>
                    <td className="px-5 py-3 text-[15px]" style={{ color: COLORS.ink }}>{r[0]}</td>
                    <td className="px-5 py-3 text-[15px] text-right font-medium" style={{ color: COLORS.accentDark }}>{r[1]}</td>
                    <td className="px-5 py-3 text-[14px] text-right" style={{ color: COLORS.ink2 }}>{r[2]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionCleaning = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bgAlt }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="12" title="Úklid a odpady" />
        <div>
          <Para>
            Úklidový režim je rozdělen do tří fází. Cílem je předat plochu po akci ve stavu
            odpovídajícímu převzetí — tedy bez stop po provozu, vč. celkového odvozu odpadu.
          </Para>
          <div className="grid md:grid-cols-3 gap-6 mt-6">
            <div className="p-6 bg-white" style={{ borderLeft: `3px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: COLORS.accentDark }}>Předakční</div>
              <p className="text-[14px]" style={{ color: COLORS.ink2 }}>Úklid plochy obou pater před instalací, odstranění stavebních zbytků, vstupní obhlídka.</p>
            </div>
            <div className="p-6 bg-white" style={{ borderLeft: `3px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: COLORS.accentDark }}>Průběžný</div>
              <p className="text-[14px]" style={{ color: COLORS.ink2 }}>Mobilní úklidový tým během celé doby provozu — sběr odpadků, čistota hygienické zóny, koše.</p>
            </div>
            <div className="p-6 bg-white" style={{ borderLeft: `3px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: COLORS.accentDark }}>Závěrečný</div>
              <p className="text-[14px]" style={{ color: COLORS.ink2 }}>Noční hluboký úklid, kompletní odvoz odpadu (komunál + tříděný), předání plochy správci.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionEntrances = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bg }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="13" title="Vstupy a evidence" />
        <div>
          <Para>
            Vstupový systém je navržen tak, aby byl reprezentativní vůči brandu Barum
            a zároveň jednoduše ovladatelný personálem na vstupu. Náramky jsou
            tištěny v barvách klienta.
          </Para>
          <BulletList items={ENTRANCE_PROCESS} />
        </div>
      </div>
    </div>
  </section>
);

const SectionPricing = ({ handleDownloadPDF }) => (
  <section className="py-20 md:py-28" style={{ background: COLORS.ink, color: '#F6F5F1' }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <div>
          <div
            className="text-xs tracking-[0.3em] font-medium mb-2"
            style={{ color: COLORS.accent, fontFamily: 'ui-monospace, monospace' }}
          >
            14
          </div>
          <h2 className="text-3xl md:text-4xl font-semibold leading-tight" style={{ fontFamily: "'Source Serif Pro', Georgia, serif" }}>
            Cenová kalkulace
          </h2>
          <div className="mt-4 h-px w-16" style={{ background: COLORS.accent }} />
        </div>
        <div>
          <p className="text-base md:text-[17px] leading-relaxed mb-6" style={{ color: '#D9D7CF' }}>
            Cenová kalkulace je strukturována do osmi výdajových bloků, které kopírují
            předchozí sekce dokumentu. Veškeré ceny jsou uvedeny <strong>bez DPH</strong>.
          </p>

          {PRICING_GROUPS.map((g) => {
            const groupTotal = calcGroupTotal(g);
            return (
              <div key={g.label} className="mb-8">
                <div
                  className="flex items-baseline justify-between mb-3 pb-2"
                  style={{ borderBottom: `1px solid ${COLORS.accent}66` }}
                >
                  <h3 className="text-base font-semibold tracking-tight" style={{ color: '#F6F5F1' }}>
                    {g.label}
                  </h3>
                  <span className="text-base font-semibold" style={{ color: COLORS.accent, fontFamily: 'ui-monospace, monospace' }}>
                    {fmt(groupTotal)}
                  </span>
                </div>
                <table className="w-full text-sm" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
                  <tbody>
                    {g.items.map((it, i) => (
                      <tr key={i}>
                        <td className="py-2 text-[14px]" style={{ color: '#D9D7CF', borderBottom: `1px solid #FFFFFF14` }}>
                          {it.name}
                        </td>
                        <td className="py-2 text-[13px] text-right whitespace-nowrap pl-4" style={{ color: '#A8A69E', borderBottom: `1px solid #FFFFFF14`, fontFamily: 'ui-monospace, monospace' }}>
                          {it.qty} {it.unit} × {fmt(it.unitPrice)}
                        </td>
                        <td className="py-2 text-[14px] text-right whitespace-nowrap pl-4 font-medium" style={{ color: '#F6F5F1', borderBottom: `1px solid #FFFFFF14` }}>
                          {fmt(it.qty * it.unitPrice)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })}

          <div className="mt-12 p-8" style={{ background: '#FFFFFF08', border: `1px solid ${COLORS.accent}55` }}>
            <div className="flex items-baseline justify-between mb-3">
              <span className="text-base" style={{ color: '#D9D7CF' }}>Mezisoučet (8 výdajových bloků)</span>
              <span className="text-xl font-semibold" style={{ color: '#F6F5F1', fontFamily: "'Source Serif Pro', Georgia, serif" }}>
                {fmt(SUBTOTAL_NO_VAT)}
              </span>
            </div>
            <div className="flex items-baseline justify-between mb-3 py-3 px-4 -mx-4" style={{ background: '#10B98115', borderLeft: `3px solid #10B981` }}>
              <div>
                <div className="text-sm font-semibold" style={{ color: '#86EFAC' }}>Odpočet — prodej vstupenek klientem</div>
                <div className="text-xs" style={{ color: '#86EFAC99' }}>{GUEST_COUNT} osob × {TICKET_PRICE} Kč vč. DPH 12 % ({fmt2(TICKET_PRICE_NET)} bez DPH) · rezervace max. 4 na zaměstnance</div>
                <div className="text-[10px] mt-0.5" style={{ color: '#86EFAC77' }}>Brutto výnos klienta: {fmt(TICKET_REVENUE_GROSS)} vč. DPH 12 %</div>
              </div>
              <span className="text-lg font-bold" style={{ color: '#86EFAC', fontFamily: 'ui-monospace, monospace' }}>
                − {fmt(TICKET_REVENUE)}
              </span>
            </div>
            <div className="flex items-baseline justify-between mb-3 py-3 px-4 -mx-4" style={{ background: '#F5A80015', borderLeft: `3px solid ${COLORS.accent}` }}>
              <div>
                <div className="text-sm font-semibold" style={{ color: COLORS.accent }}>Finální obchodní sleva</div>
                <div className="text-xs" style={{ color: '#A8A69E' }}>Kompletní zakázka — partnerský benefit při zachování kvality služeb</div>
              </div>
              <span className="text-lg font-bold" style={{ color: COLORS.accent, fontFamily: 'ui-monospace, monospace' }}>
                − {fmt(FINAL_DISCOUNT)}
              </span>
            </div>

            <div className="flex items-baseline justify-between mb-3 pt-4" style={{ borderTop: `1px solid #FFFFFF22` }}>
              <span className="text-base" style={{ color: '#D9D7CF' }}>Celkem bez DPH</span>
              <span className="text-2xl font-semibold" style={{ color: '#F6F5F1', fontFamily: "'Source Serif Pro', Georgia, serif" }}>
                {fmt(TOTAL_NO_VAT)}
              </span>
            </div>
            <div className="flex items-baseline justify-between mb-3">
              <span className="text-sm" style={{ color: '#A8A69E' }}>DPH 21 % (orientačně)</span>
              <span className="text-sm" style={{ color: '#A8A69E', fontFamily: 'ui-monospace, monospace' }}>
                + {fmt(TOTAL_NO_VAT * VAT_RATE)}
              </span>
            </div>
            <div className="flex items-baseline justify-between pt-4" style={{ borderTop: `1px solid ${COLORS.accent}55` }}>
              <span className="text-lg font-medium" style={{ color: '#F6F5F1' }}>Celkem s DPH</span>
              <span className="text-3xl font-bold" style={{ color: COLORS.accent, fontFamily: "'Source Serif Pro', Georgia, serif" }} data-testid="barum-total-with-vat">
                {fmt(TOTAL_WITH_VAT)}
              </span>
            </div>
            <div className="mt-6 text-xs" style={{ color: '#A8A69E', fontFamily: "'Inter', system-ui, sans-serif" }}>
              Cena na osobu (bez DPH, kapacita {GUEST_COUNT}): <strong style={{ color: '#F6F5F1' }}>{fmt(TOTAL_NO_VAT / GUEST_COUNT)}</strong>.
              Komerční bar (lihoviny a koktejly) není součástí této kalkulace — provozujeme jej ve vlastní režii.
            </div>
          </div>

          <div className="mt-10 text-center">
            <button
              type="button"
              onClick={handleDownloadPDF}
              data-testid="barum-download-pdf"
              className="inline-flex items-center gap-3 px-8 py-4 font-medium tracking-wide transition-all"
              style={{ background: COLORS.accent, color: COLORS.ink, fontFamily: "'Inter', system-ui, sans-serif" }}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              </svg>
              Stáhnout nabídku v PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionPartnership = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bg }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="15" title="Návrh dlouhodobé spolupráce 2026 – 2028" />
        <div>
          <Para>
            Nabídku koncipujeme jako základ pro <strong>tříletou rámcovou spolupráci</strong>
            na ročnících 2026, 2027 a 2028. Tříletý horizont umožňuje:
          </Para>
          <BulletList items={[
            'Postupné rozšiřování VIP / hospitality kapacity a programu',
            'Fixaci nákupních cen mobiliáře a TOI TOI proti inflaci',
            'Jednotnou vizuální linku napříč ročníky (brandbook Continental)',
            'Reportování návštěvnosti a efektivity gastro zón po každém ročníku',
            'Možnost vyjednat exkluzivitu vůči konkurenčním brand zónám rally',
          ]} />
          <div className="grid md:grid-cols-3 gap-6 mt-6">
            <div className="p-6 bg-white" style={{ borderTop: `2px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: COLORS.accentDark }}>2026</div>
              <div className="text-base" style={{ color: COLORS.ink }}>Pilotní ročník — VIP / hospitality zóna 900 osob</div>
            </div>
            <div className="p-6 bg-white" style={{ borderTop: `2px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: COLORS.accentDark }}>2027</div>
              <div className="text-base" style={{ color: COLORS.ink }}>Rozšíření o doprovodný program a brandové instalace</div>
            </div>
            <div className="p-6 bg-white" style={{ borderTop: `2px solid ${COLORS.accent}` }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: COLORS.accentDark }}>2028</div>
              <div className="text-base" style={{ color: COLORS.ink }}>Plně integrovaná hospitality platforma napříč třídenní rally</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const SectionConclusion = () => (
  <section className="py-20 md:py-28" style={{ background: COLORS.bgAlt }}>
    <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid md:grid-cols-[180px_1fr] gap-10">
        <SectionLabel number="16" title="Závěr" />
        <div>
          <Para>
            Předkládaná nabídka představuje kompletní technicko-organizační řešení
            VIP a hospitality zóny pro Barum Czech Rally Zlín 2026 ve standardu
            odpovídajícím požadavkům značky Continental. Veškeré položky jsou
            podloženy reálnými dodavatelskými cenami pro daný rozsah akce.
          </Para>
          <Para>
            Po předběžném odsouhlasení rozsahu jsme připraveni dohodnout společnou
            obhlídku, finalizovat zónování plochy a podepsat smlouvu o dílo.
            V případě tříletého rámce nabízíme indexovanou cenu se zafixovanou
            hladinou klíčových položek.
          </Para>

          <div className="grid md:grid-cols-2 gap-6 mt-8">
            <div className="p-6 bg-white">
              <div className="text-xs tracking-[0.2em] uppercase mb-3" style={{ color: COLORS.accentDark }}>Kontakt dodavatele</div>
              <KeyValueRow k="Kontakt" v={META.supplier.contact} />
              <KeyValueRow k="Telefon" v={META.supplier.phone} />
              <KeyValueRow k="E-mail" v={META.supplier.email} />
              <KeyValueRow k="IČO" v={META.supplier.ico} />
              <KeyValueRow k="DIČ" v={META.supplier.dic} />
            </div>
            <div className="p-6 bg-white">
              <div className="text-xs tracking-[0.2em] uppercase mb-3" style={{ color: COLORS.accentDark }}>Akce</div>
              <KeyValueRow k="Klient" v="Barum Continental" />
              <KeyValueRow k="Termín" v={META.date} />
              <KeyValueRow k="Provoz" v="17:30 – 23:30" />
              <KeyValueRow k="Místo" v="Garáže u 21. budovy, Zlín" />
              <KeyValueRow k="Kapacita" v={META.capacity} />
              <KeyValueRow k="Cena celkem" v={fmt(TOTAL_NO_VAT) + ' (bez DPH)'} accent />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// ---------- PDF ----------
const buildPdf = () => {
  // -------- Design tokens --------
  const C = {
    ink: '#111317', ink2: '#3B3F45', muted: '#6B7280',
    accent: '#B07900', amber: '#F5A800', amberLight: '#FCE9B6',
    paper: '#F6F5F1', paperAlt: '#EEEBE0',
    hair: '#E2E0D8', white: '#FFFFFF',
  };

  // -------- Helpers --------
  const sectionHeader = (num, title, opts = {}) => ([
    {
      table: {
        widths: ['auto', '*'],
        body: [[
          {
            text: num,
            fontSize: 36,
            bold: true,
            color: C.amber,
            margin: [0, 0, 0, 0],
            border: [false, false, false, false],
          },
          {
            stack: [
              { text: title.toUpperCase(), fontSize: 7, color: C.muted, characterSpacing: 2.5, margin: [0, 6, 0, 2] },
              { text: title, fontSize: 20, bold: true, color: C.ink, margin: [0, 0, 0, 2] },
              { canvas: [{ type: 'rect', x: 0, y: 0, w: 44, h: 2, color: C.amber }] },
            ],
            border: [false, false, false, false],
            margin: [10, 0, 0, 0],
          },
        ]],
      },
      layout: 'noBorders',
      pageBreak: opts.pageBreak,
      margin: [0, opts.first ? 0 : 14, 0, 16],
    },
  ]);

  const para = (text) => ({ text, fontSize: 10.5, color: C.ink2, lineHeight: 1.55, margin: [0, 0, 0, 8] });

  const bulletList = (items) => ({
    ul: items.map((t) => ({ text: t, fontSize: 10, color: C.ink2, lineHeight: 1.45, margin: [0, 0, 0, 2] })),
    color: C.amber,
    margin: [0, 0, 0, 10],
  });

  const simpleTable = (rows, widths = ['30%', '*']) => ({
    table: {
      widths,
      body: rows.map((r) => r.map((cell, i) => ({
        text: cell,
        fontSize: 9.5,
        color: i === 0 ? C.ink : C.ink2,
        bold: i === 0,
        margin: [0, 5, 0, 5],
      }))),
    },
    layout: 'lightHorizontalLines',
    margin: [0, 0, 0, 12],
  });

  const subLabel = (t) => ({
    text: t,
    fontSize: 8,
    bold: true,
    color: C.accent,
    characterSpacing: 2,
    margin: [0, 8, 0, 6],
  });

  // Card with amber top accent + cream fill
  const card = (heading, contentStack) => ({
    table: {
      widths: ['*'],
      body: [
        [{
          canvas: [{ type: 'rect', x: 0, y: 0, w: 240, h: 2.5, color: C.amber }],
          border: [false, false, false, false],
        }],
        [{
          stack: [
            { text: heading.toUpperCase(), fontSize: 8, color: C.accent, characterSpacing: 1.8, margin: [0, 8, 0, 6] },
            ...contentStack,
          ],
          fillColor: C.paper,
          border: [false, false, false, false],
          margin: [12, 0, 12, 12],
        }],
      ],
    },
    layout: 'noBorders',
  });

  // 2 columns of cards
  const cardGrid = (cards) => {
    const rows = [];
    for (let i = 0; i < cards.length; i += 2) {
      rows.push([cards[i] || {}, cards[i + 1] || {}]);
    }
    return {
      table: { widths: ['*', '*'], body: rows },
      layout: { defaultBorder: false, paddingLeft: () => 0, paddingRight: (i) => (i === 0 ? 8 : 0), paddingTop: () => 0, paddingBottom: () => 12 },
      margin: [0, 0, 0, 6],
    };
  };

  // KPI box (used for mobiliář, security, etc.) — label up, big value below
  const kpiBox = (label, value) => ({
    stack: [
      { canvas: [{ type: 'rect', x: 0, y: 0, w: 28, h: 2, color: C.amber }], margin: [0, 0, 0, 6] },
      { text: label.toUpperCase(), fontSize: 7, color: C.muted, characterSpacing: 1.5, margin: [0, 0, 0, 4] },
      { text: value, fontSize: 11, bold: true, color: C.ink },
    ],
    fillColor: C.paper,
    margin: [12, 12, 12, 12],
  });

  const kpiGrid = (boxes, cols = 3) => {
    const rows = [];
    for (let i = 0; i < boxes.length; i += cols) {
      const row = [];
      for (let j = 0; j < cols; j++) {
        row.push(boxes[i + j] ? { ...boxes[i + j], border: [false, false, false, false] } : { text: '', border: [false, false, false, false] });
      }
      rows.push(row);
    }
    return {
      table: { widths: Array(cols).fill('*'), body: rows },
      layout: { defaultBorder: false, paddingLeft: (i) => (i === 0 ? 0 : 4), paddingRight: (i) => (i === cols - 1 ? 0 : 4), paddingTop: () => 0, paddingBottom: () => 8 },
      margin: [0, 0, 0, 10],
    };
  };

  // Reference card (amber top bar + content + insight footer)
  const refCard = (r) => ({
    table: {
      widths: ['*'],
      body: [
        [{ canvas: [{ type: 'rect', x: 0, y: 0, w: 480, h: 3, color: C.amber }], border: [false, false, false, false] }],
        [{
          stack: [
            { text: r.tag.toUpperCase(), fontSize: 7, color: C.accent, characterSpacing: 1.8, margin: [0, 10, 0, 4] },
            { text: r.title, fontSize: 14, bold: true, color: C.ink, margin: [0, 0, 0, 6] },
            { text: r.description, fontSize: 9.5, color: C.ink2, lineHeight: 1.45, margin: [0, 0, 0, 10] },
            {
              columns: [
                { stack: [
                  { text: 'ROZSAH', fontSize: 7, color: C.accent, characterSpacing: 1.5 },
                  { text: r.stats, fontSize: 9, bold: true, color: C.ink, margin: [0, 2, 0, 0] },
                ] },
                { stack: [
                  { text: 'KLIENT', fontSize: 7, color: C.accent, characterSpacing: 1.5 },
                  { text: r.client, fontSize: 9, bold: true, color: C.ink, margin: [0, 2, 0, 0] },
                ] },
                { stack: [
                  { text: 'REALIZACE', fontSize: 7, color: C.accent, characterSpacing: 1.5 },
                  { text: r.date, fontSize: 9, bold: true, color: C.ink, margin: [0, 2, 0, 0] },
                ] },
              ],
              columnGap: 8,
            },
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 480, y2: 0, lineWidth: 0.5, lineColor: C.hair }], margin: [0, 10, 0, 6] },
            { text: '→ ' + r.insight, fontSize: 9, italics: true, color: C.ink2 },
          ],
          fillColor: C.paper,
          border: [false, false, false, false],
          margin: [16, 0, 16, 16],
        }],
      ],
    },
    layout: 'noBorders',
    margin: [0, 0, 0, 12],
    unbreakable: true,
  });

  // -------- Section blocks --------
  // 03 Rozsah služeb
  const SCOPE_ITEMS = [
    'Projektový management a koordinace',
    'Logistika a doprava',
    'Mobiliář (pivní sety, layout zóny)',
    'Hygienické zázemí (TOI TOI)',
    'Catering – základní program zdarma',
    'Komerční bar (lihoviny a koktejly)',
    'Elektro, ozvučení, osvětlení',
    'Bezpečnost a ostraha',
    'Předakční, průběžný a noční úklid',
    'Vstupový systém a evidence',
    'Odpadové hospodářství',
    'Závěrečné předání plochy',
  ];

  const TECH_BLOCKS = [
    { h: 'Elektro rozvody', items: ['Hlavní rozvaděč + 6 podružných', 'Kabeláž s mechanickou ochranou', 'Kompletní revize a značení', 'Stavební zábrany kabelových tras'] },
    { h: 'Záložní napájení', items: ['UPS jednotka pro citlivá zařízení', 'Motorgenerátor v záloze (silent diesel)', 'Plynulé přepnutí v případě výpadku'] },
    { h: 'Osvětlení', items: ['LED dekorativní osvětlení gastro zóny', 'Funkční osvětlení výdejních míst', 'Bezpečnostní nouzové osvětlení', 'Atmosférická scéna na celé střeše'] },
    { h: 'Ozvučení', items: ['PA systém pro 900 osob, distribuované zóny', 'Bezdrátové mikrofony pro klienta', 'Připojení signálu z RZ (komentátor)', 'Limit hladiny dle hygienických norem'] },
  ];

  const PERSONNEL_ROWS = [
    ['Projektový manažer', 1, 'celý den'],
    ['Koordinátor cateringu', 1, 'celý den'],
    ['Kuchaři + live cooking', 6, '12 hod'],
    ['Výdejní personál (catering)', 12, '8 hod'],
    ['Výčepní (4 výčepy)', 8, '8 hod'],
    ['Pomocný personál + sklad', 4, '10 hod'],
    ['Premium bar (mixology)', 3, '6 hod'],
    ['Manipulační tým — mobiliář', 6, 'instalace + svoz'],
    ['Technický dozor', 1, 'celý den'],
    ['Ostraha (security)', 8, '8 hod'],
    ['Noční ostraha (s psem)', 1, 'po skončení'],
    ['Distribuce vstupenek', 2, 'předakční týden'],
    ['Úklidový tým', 4, 'průběžně + noc'],
  ];

  const groupTables = PRICING_GROUPS.map((g) => ({
    stack: [
      { text: g.label, bold: true, fontSize: 11, color: C.ink, margin: [0, 10, 0, 4] },
      {
        table: {
          headerRows: 0,
          widths: ['*', 'auto', 'auto'],
          body: g.items.map((it) => ([
            { text: it.name, fontSize: 9, color: C.ink2 },
            { text: `${it.qty} ${it.unit} × ${fmt(it.unitPrice)}`, fontSize: 8, color: C.muted, alignment: 'right' },
            { text: fmt(it.qty * it.unitPrice), fontSize: 9, alignment: 'right', color: C.ink },
          ])),
        },
        layout: 'lightHorizontalLines',
      },
      {
        table: {
          widths: ['*', 'auto'],
          body: [[
            { text: 'Mezisoučet bloku', fontSize: 9, italics: true, color: C.muted, margin: [0, 4, 0, 4] },
            { text: fmt(calcGroupTotal(g)), fontSize: 10, bold: true, alignment: 'right', color: C.accent, margin: [0, 4, 0, 4] },
          ]],
        },
        layout: 'noBorders',
      },
    ],
  }));

  return {
    pageMargins: [50, 60, 50, 70],
    background: (currentPage, pageSize) => {
      if (currentPage === 1) {
        return {
          canvas: [
            { type: 'rect', x: 0, y: 0, w: pageSize.width, h: pageSize.height, color: C.ink },
            // accent diagonal lines (subtle pattern)
            { type: 'rect', x: 0, y: pageSize.height - 60, w: pageSize.width, h: 60, color: '#000000' },
            { type: 'rect', x: 0, y: pageSize.height - 60, w: 80, h: 4, color: C.amber },
          ],
        };
      }
      return null;
    },
    footer: (currentPage, pageCount) => {
      if (currentPage === 1) return null;
      return {
        table: {
          widths: ['*', 'auto'],
          body: [[
            {
              text: 'BCR/2026/HOSP-21  ·  Vše pro akci  ·  Otrokovice  ·  2026',
              fontSize: 7,
              color: C.muted,
              characterSpacing: 0.6,
              margin: [50, 14, 0, 0],
              border: [false, true, false, false],
              borderColor: [C.hair, C.hair, C.hair, C.hair],
            },
            {
              text: `${currentPage} / ${pageCount}`,
              fontSize: 8,
              bold: true,
              color: C.accent,
              alignment: 'right',
              margin: [0, 14, 50, 0],
              border: [false, true, false, false],
              borderColor: [C.hair, C.hair, C.hair, C.hair],
            },
          ]],
        },
        layout: {
          hLineColor: () => C.hair,
          hLineWidth: (i) => (i === 0 ? 0.5 : 0),
          vLineWidth: () => 0,
        },
      };
    },
    content: [
      // ========== PAGE 1 — COVER (dark) ==========
      { text: '', margin: [0, 40, 0, 0] }, // top spacing
      { text: 'OBCHODNÍ NABÍDKA', fontSize: 9, color: C.amber, characterSpacing: 4, margin: [0, 0, 0, 4] },
      { text: 'EVENT PRODUCTION', fontSize: 9, color: C.muted, characterSpacing: 4, margin: [0, 0, 0, 60] },

      { text: 'VIP / Hospitality', fontSize: 38, bold: true, color: C.white, lineHeight: 1.05, margin: [0, 0, 0, 0] },
      { text: 'zóna', fontSize: 38, bold: true, color: C.amber, lineHeight: 1.05, margin: [0, 0, 0, 10] },
      { canvas: [{ type: 'rect', x: 0, y: 0, w: 70, h: 3, color: C.amber }], margin: [0, 0, 0, 20] },
      { text: 'Barum Czech Rally Zlín', fontSize: 22, color: C.white, margin: [0, 0, 0, 6] },
      { text: 'Páteční městská RZ — střecha garáží u 21. budovy', fontSize: 11, color: '#D9D7CF', italics: true, margin: [0, 0, 0, 60] },

      // Meta blocks - 4 columns on cover
      {
        table: {
          widths: ['*', '*', '*', '*'],
          body: [[
            {
              stack: [
                { text: 'KLIENT', fontSize: 7, color: C.amber, characterSpacing: 2, margin: [0, 0, 0, 4] },
                { text: 'Barum', fontSize: 13, bold: true, color: C.white },
                { text: 'Continental', fontSize: 13, bold: true, color: C.white },
              ],
              border: [false, true, false, false],
              borderColor: ['#FFFFFF33', '#FFFFFF33', '#FFFFFF33', '#FFFFFF33'],
              margin: [0, 14, 8, 0],
            },
            {
              stack: [
                { text: 'TERMÍN', fontSize: 7, color: C.amber, characterSpacing: 2, margin: [0, 0, 0, 4] },
                { text: 'pátek', fontSize: 11, color: '#D9D7CF' },
                { text: '14. 8. 2026', fontSize: 13, bold: true, color: C.white, margin: [0, 1, 0, 0] },
              ],
              border: [false, true, false, false],
              borderColor: ['#FFFFFF33', '#FFFFFF33', '#FFFFFF33', '#FFFFFF33'],
              margin: [8, 14, 8, 0],
            },
            {
              stack: [
                { text: 'KAPACITA', fontSize: 7, color: C.amber, characterSpacing: 2, margin: [0, 0, 0, 4] },
                { text: '900', fontSize: 13, bold: true, color: C.white },
                { text: 'osob', fontSize: 11, color: '#D9D7CF' },
              ],
              border: [false, true, false, false],
              borderColor: ['#FFFFFF33', '#FFFFFF33', '#FFFFFF33', '#FFFFFF33'],
              margin: [8, 14, 8, 0],
            },
            {
              stack: [
                { text: 'PROVOZ', fontSize: 7, color: C.amber, characterSpacing: 2, margin: [0, 0, 0, 4] },
                { text: '17:30', fontSize: 13, bold: true, color: C.white },
                { text: '— 23:30', fontSize: 13, bold: true, color: C.white },
              ],
              border: [false, true, false, false],
              borderColor: ['#FFFFFF33', '#FFFFFF33', '#FFFFFF33', '#FFFFFF33'],
              margin: [8, 14, 0, 0],
            },
          ]],
        },
        layout: {
          hLineColor: () => '#FFFFFF33',
          hLineWidth: (i) => (i === 0 ? 0.6 : 0),
          vLineWidth: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
        margin: [0, 0, 0, 0],
      },

      // Cover footer - document info
      { text: 'DOKUMENT č. BCR/2026/HOSP-21  ·  VERZE 1.0  ·  OTROKOVICE', fontSize: 7, color: '#A8A69E', characterSpacing: 2, margin: [0, 130, 0, 0] },

      // ========== PAGE 2 — TABLE OF CONTENTS ==========
      { text: '', pageBreak: 'before' },
      { text: 'OBSAH', fontSize: 7, color: C.muted, characterSpacing: 3, margin: [0, 0, 0, 4] },
      { text: 'Struktura dokumentu', fontSize: 24, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
      { canvas: [{ type: 'rect', x: 0, y: 0, w: 50, h: 2.5, color: C.amber }], margin: [0, 0, 0, 22] },
      {
        table: {
          widths: ['auto', '*'],
          body: [
            ['01', 'Úvod'],
            ['02', 'Pochopení zadání'],
            ['03', 'Rozsah služeb'],
            ['04', 'Logistika a dostupnost'],
            ['05', 'Harmonogram dne'],
            ['06', 'Technické zajištění'],
            ['07', 'Catering'],
            ['08', 'Mobiliář'],
            ['09', 'Hygienické zázemí (TOI TOI)'],
            ['10', 'Bezpečnost a ostraha'],
            ['11', 'Personální zajištění'],
            ['12', 'Úklid a odpady'],
            ['13', 'Vstupy a evidence'],
            ['14', 'Cenová kalkulace'],
            ['R', 'Reference'],
            ['15', 'Návrh dlouhodobé spolupráce 2026 – 2028'],
            ['16', 'Závěr'],
          ].map(([n, t]) => [
            { text: n, fontSize: 16, bold: true, color: C.amber, margin: [0, 6, 16, 6] },
            { text: t, fontSize: 12, color: C.ink, margin: [0, 11, 0, 6] },
          ]),
        },
        layout: {
          hLineWidth: (i) => 0.5,
          hLineColor: () => C.hair,
          vLineWidth: () => 0,
          paddingLeft: () => 0,
          paddingRight: () => 0,
        },
        margin: [0, 0, 0, 0],
      },

      // ========== PAGE 3 — 01 Úvod ==========
      { text: '', pageBreak: 'before' },
      ...sectionHeader('01', 'Úvod', { first: true }),
      para('Děkujeme za příležitost ucházet se o realizaci VIP a hospitality zóny pro Barum Czech Rally Zlín 2026. Předkládáme komplexní technicko-organizační nabídku pokrývající kompletní zajištění páteční městské rychlostní zkoušky na střeše garáží u 21. budovy.'),
      para('Naše agentura má zkušenost s realizací firemních eventů pro 200 – 3 500 hostů, včetně náročných venkovních a víceúrovňových lokací. Nabídka je strukturována tak, aby pokrývala všechny aspekty produkce — od logistiky a techniky přes catering, mobiliář a hygienické zázemí až po bezpečnost a vstupový systém.'),
      para('Cenová úroveň odpovídá náročnosti akce, kapacitě 900 hostů a kvalitativnímu standardu očekávanému od značky Continental. Dokument je zároveň koncipován jako základ pro dlouhodobou spolupráci v letech 2026 – 2028.'),

      // ---------- 02 Pochopení zadání ----------
      ...sectionHeader('02', 'Pochopení zadání'),
      para('Cílem je vytvoření exkluzivního diváckého a hospitality prostoru pro klienta a jeho VIP hosty během páteční městské rychlostní zkoušky. Lokace je specifická — dvě patra střechy garážového objektu — což klade vyšší nároky na logistiku, bezpečnost evakuačních cest a technickou připravenost.'),
      para('Akce probíhá v podvečerních a večerních hodinách, což znamená nutnost dokončit kompletní instalaci do 16:00 a po skončení provést bezpečný noční úklid s kompletním odvozem techniky tak, aby ráno byl prostor plně předaný správci objektu.'),
      subLabel('KLÍČOVÁ SPECIFIKA'),
      bulletList([
        'Dvě patra (předposlední a poslední), vertikální logistika',
        'Hosté přicházejí kontinuálně – nutno řešit tok davu',
        '900 osob bez kapacitních rezerv na chybu',
        'Práce v nočních hodinách (úklid, demontáž)',
      ]),
      subLabel('NAŠE ODPOVĚDNOST'),
      bulletList([
        'Plný projektový management end-to-end',
        'Koordinace s pořadatelem RZ a městem Zlín',
        'Bezpečnost hostů a respekt k brandu Barum',
        'Předání plochy po akci ve stavu před převzetím',
      ]),

      // ---------- 03 Rozsah služeb ----------
      ...sectionHeader('03', 'Rozsah služeb'),
      para('Nabídka pokrývá kompletní dodávku služeb v režimu „end-to-end". Klient nepotřebuje pro realizaci samostatně řešit žádné z níže uvedených oblastí — vše je zajištěno v rámci jednoho dodavatelského vztahu.'),
      {
        table: {
          widths: ['*', '*'],
          body: (() => {
            const rows = [];
            for (let i = 0; i < SCOPE_ITEMS.length; i += 2) {
              const cell = (idx) => idx < SCOPE_ITEMS.length ? {
                stack: [
                  { text: String(idx + 1).padStart(2, '0'), fontSize: 9, bold: true, color: C.amber, characterSpacing: 1.5 },
                  { text: SCOPE_ITEMS[idx], fontSize: 10, color: C.ink, margin: [0, 3, 0, 0] },
                ],
                margin: [12, 10, 12, 10],
                fillColor: C.paper,
                border: [false, false, false, false],
              } : { text: '', border: [false, false, false, false] };
              rows.push([cell(i), cell(i + 1)]);
            }
            return rows;
          })(),
        },
        layout: { defaultBorder: false, paddingLeft: (i) => (i === 0 ? 0 : 4), paddingRight: (i) => (i === 0 ? 4 : 0), paddingTop: () => 0, paddingBottom: () => 6 },
        margin: [0, 0, 0, 10],
      },

      // ---------- 04 Logistika ----------
      ...sectionHeader('04', 'Logistika a dostupnost'),
      para('Vzhledem ke specifické lokaci (vyvýšená střecha garážového objektu, dvě patra) vyžaduje akce přesné fázování dodávek, omezený počet vozidel v jeden moment a koordinaci s pořadatelem rally a městskou policií.'),
      bulletList([
        'Předakční obhlídka (technická + cestovní) – min. 2 návštěvy před akcí',
        'Plán nájezdů techniky rozdělený do 4 časových slotů (kapacita parkoviště)',
        'Jednotná logistická koordinace přes vedoucího produkce',
      ]),

      // ---------- 05 Harmonogram ----------
      ...sectionHeader('05', 'Harmonogram dne', { pageBreak: 'before' }),
      para('Akce probíhá v jednom dni — pátek 14. 8. 2026. Příprava začíná v ranních hodinách, hosté přicházejí od 17:30, kompletní úklid a odvoz techniky končí do 6:00 ráno následujícího dne.'),
      {
        table: {
          headerRows: 1,
          widths: ['auto', '*'],
          body: [
            [
              { text: 'ČAS', fontSize: 8, bold: true, color: '#FFFFFF', fillColor: C.ink, characterSpacing: 1.5, margin: [0, 6, 0, 6] },
              { text: 'AKTIVITA', fontSize: 8, bold: true, color: '#FFFFFF', fillColor: C.ink, characterSpacing: 1.5, margin: [0, 6, 0, 6] },
            ],
            ...SCHEDULE.map((row) => [
              { text: row.time, fontSize: 9, bold: true, color: C.accent, margin: [0, 4, 0, 4] },
              { text: row.task, fontSize: 9, color: C.ink2, margin: [0, 4, 0, 4] },
            ]),
          ],
        },
        layout: 'lightHorizontalLines',
        margin: [0, 0, 0, 12],
      },

      // ---------- 06 Technické zajištění ----------
      ...sectionHeader('06', 'Technické zajištění'),
      para('Kompletní technologická vrstva — energetika, kabeláž, ozvučení a osvětlení. Veškerá řešení jsou navržena s ohledem na bezpečnostní normy ČSN, redundantní napájení a venkovní provoz v případě nepříznivého počasí.'),
      cardGrid(TECH_BLOCKS.map((b) => card(b.h, [
        {
          ul: b.items.map((t) => ({ text: t, fontSize: 9, color: C.ink2, lineHeight: 1.4 })),
          color: C.amber,
          margin: [0, 0, 0, 4],
        },
      ]))),

      // ---------- 07 Catering ----------
      ...sectionHeader('07', 'Catering', { pageBreak: 'before' }),
      para('Catering je rozdělen do dvou vrstev: základní program zdarma pro všechny hosty (hrazený klientem) — kompletní jídelní a nápojový mix — a komerční bar s lihovinami a koktejly, který si platí přímo host. Tato struktura vyvažuje pohostinnost značky a finanční efektivitu nabídky.'),
      subLabel('ZÁKLADNÍ PROGRAM — ZDARMA PRO HOSTY (HRAZENO KLIENTEM)'),
      subLabel('· Jídelní nabídka'),
      simpleTable(CATERING_FREE_FOOD.map((c) => [c.item, c.detail])),
      subLabel('· Nápoje — čepované'),
      simpleTable(CATERING_FREE_DRINKS.map((c) => [c.item, c.detail])),
      subLabel('KOMERČNÍ BAR — LIHOVINY A KOKTEJLY (SAMOSTATNÁ EKONOMIKA)'),
      simpleTable(CATERING_PAID.map((c) => [c.item, c.detail])),
      { text: 'Komerční bar provozujeme ve vlastní režii — výnos z prodeje lihovin a koktejlů není součástí faktury klientovi. Brand klienta je viditelně přítomen (značení, servírovací prvky).', fontSize: 9, italics: true, color: C.muted, margin: [0, 0, 0, 12] },

      // ---------- 08 Mobiliář ----------
      ...sectionHeader('08', 'Mobiliář'),
      para('Pivní sety jsou vhodnou volbou pro tento typ akce — kombinují vysokou kapacitu, rychlou instalaci a kulturní fit s prostředím rally. Cena 200 Kč / ks zahrnuje dopravu, rozmístění a následný svoz.'),
      kpiGrid([
        kpiBox('Počet setů', 'cca 110 ks'),
        kpiBox('Kapacita', '~880 míst'),
        kpiBox('Layout', 'Obě patra'),
        kpiBox('Manipulace', '6 osob'),
        kpiBox('Cena za set', '200 Kč (D + I + S)'),
        kpiBox('Doplňky', 'Koktejlové stoly'),
      ]),
      para('Konečný počet setů upřesníme po obhlídce — záleží na finálním zónování, evakuačních koridorech a pozici premium baru. Předpokládáme rezervu 5 – 10 setů.'),

      // ---------- 09 TOI TOI ----------
      ...sectionHeader('09', 'Hygienické zázemí (TOI TOI)'),
      para('Sanitární zázemí je dimenzováno přesně podle požadavku — celkem 16 jednotek rozdělených mezi obě patra. Cena 2 000 Kč za jednotku zahrnuje pronájem, dopravu, instalaci a likvidaci. Kromě toho zajišťujeme kompletní obslužnou vrstvu.'),
      kpiGrid([
        kpiBox('Spodní patro', '6 ks × 2 000 Kč'),
        kpiBox('Horní patro', '10 ks × 2 000 Kč'),
        kpiBox('Obsluha', '2 osoby / směna'),
      ], 3),
      bulletList([
        'Pravidelný servis během akce (doplnění hygienických potřeb, kontrola)',
        'Stálá obsluha hygienické zóny — 2 osoby ve směně',
        'Průběžný úklid a hygienická kontrola',
        'Lokální osvětlení zóny (LED, bezpečnostní)',
        'Stavební zábrany a směrové značení',
        'Závěrečný noční úklid sanitárních prostorů',
      ]),

      // ---------- 10 Bezpečnost ----------
      ...sectionHeader('10', 'Bezpečnost a ostraha'),
      para('Bezpečnost je zajištěna licencovanou ostrahou s eventovými zkušenostmi. Konfigurace zohledňuje dvoupatrovou strukturu, kontinuální průtok hostů a nutnost večerního a nočního dohledu.'),
      kpiGrid([
        kpiBox('Security tým', '8 osob × 8 hodin'),
        kpiBox('Noční ostraha', '1 osoba + pes'),
        kpiBox('Vedoucí směny', '1 osoba'),
        kpiBox('Kontrola vstupů', '2 stanice'),
        kpiBox('Dohled gastro', 'Bar + výčepy'),
        kpiBox('Evakuace', 'Označ. trasy'),
      ]),

      // ---------- 11 Personál ----------
      ...sectionHeader('11', 'Personální zajištění', { pageBreak: 'before' }),
      para('Akce vyžaduje cca 54 členů personálu v různých rolích. Celý tým je řízen jedním projektovým manažerem a koordinátorem cateringu.'),
      {
        table: {
          headerRows: 1,
          widths: ['*', 'auto', 'auto'],
          body: [
            [
              { text: 'ROLE', fontSize: 8, bold: true, color: '#FFFFFF', fillColor: C.ink, characterSpacing: 1.5, margin: [0, 6, 0, 6] },
              { text: 'POČET', fontSize: 8, bold: true, color: '#FFFFFF', fillColor: C.ink, characterSpacing: 1.5, alignment: 'right', margin: [0, 6, 0, 6] },
              { text: 'PROVOZ', fontSize: 8, bold: true, color: '#FFFFFF', fillColor: C.ink, characterSpacing: 1.5, alignment: 'right', margin: [0, 6, 0, 6] },
            ],
            ...PERSONNEL_ROWS.map((r) => [
              { text: r[0], fontSize: 9, color: C.ink, margin: [0, 4, 0, 4] },
              { text: String(r[1]), fontSize: 9, bold: true, color: C.accent, alignment: 'right', margin: [0, 4, 0, 4] },
              { text: r[2], fontSize: 9, color: C.ink2, alignment: 'right', margin: [0, 4, 0, 4] },
            ]),
          ],
        },
        layout: 'lightHorizontalLines',
        margin: [0, 0, 0, 12],
      },

      // ---------- 12 Úklid ----------
      ...sectionHeader('12', 'Úklid a odpady'),
      para('Úklidový režim je rozdělen do tří fází. Cílem je předat plochu po akci ve stavu odpovídajícímu převzetí — tedy bez stop po provozu, vč. celkového odvozu odpadu.'),
      simpleTable([
        ['Předakční', 'Úklid plochy obou pater před instalací, odstranění stavebních zbytků, vstupní obhlídka.'],
        ['Průběžný', 'Mobilní úklidový tým během celé doby provozu — sběr odpadků, čistota hygienické zóny, koše.'],
        ['Závěrečný', 'Noční hluboký úklid, kompletní odvoz odpadu (komunál + tříděný), předání plochy správci.'],
      ]),

      // ---------- 13 Vstupy ----------
      ...sectionHeader('13', 'Vstupy a evidence'),
      para('Vstupový systém je navržen tak, aby byl reprezentativní vůči brandu Barum a zároveň jednoduše ovladatelný personálem na vstupu. Náramky jsou tištěny v barvách klienta.'),
      bulletList(ENTRANCE_PROCESS),

      // ---------- 14 Cenová kalkulace ----------
      ...sectionHeader('14', 'Cenová kalkulace', { pageBreak: 'before' }),
      { text: 'Cenová kalkulace je strukturována do osmi výdajových bloků. Veškeré ceny jsou uvedeny bez DPH.', fontSize: 10, color: C.ink2, italics: true, margin: [0, 0, 0, 10] },
      ...groupTables,
      // Mezisoučet + odpočet + sleva (rozšířený rozpočet v dark boxu)
      {
        table: {
          widths: ['*', 'auto'],
          body: [
            [
              { text: 'MEZISOUČET (8 BLOKŮ)', fontSize: 8.5, color: '#A8A69E', characterSpacing: 1.5, margin: [16, 14, 0, 4], border: [false, false, false, false], fillColor: C.ink },
              { text: fmt(SUBTOTAL_NO_VAT), fontSize: 14, bold: true, color: C.white, alignment: 'right', margin: [0, 12, 16, 4], border: [false, false, false, false], fillColor: C.ink },
            ],
          ],
        },
        layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingTop: () => 0, paddingBottom: () => 0 },
        margin: [0, 16, 0, 0],
      },
      // Odpočet — prodej vstupenek (zelený)
      {
        table: {
          widths: [3, '*'],
          body: [[
            { canvas: [{ type: 'rect', x: 0, y: 0, w: 3, h: 66, color: '#10B981' }], border: [false, false, false, false], fillColor: '#10B98115' },
            {
              stack: [
                { text: 'ODPOČET — PRODEJ VSTUPENEK KLIENTEM', fontSize: 8, color: '#059669', bold: true, characterSpacing: 1.5, margin: [0, 8, 0, 2] },
                { text: `${GUEST_COUNT} osob × ${TICKET_PRICE} Kč vč. DPH 12 % (${fmt2(TICKET_PRICE_NET)} bez DPH) · rezervace max. 4 na zaměstnance`, fontSize: 8, color: '#065F46', margin: [0, 0, 0, 1] },
                { text: `Brutto výnos klienta: ${fmt(TICKET_REVENUE_GROSS)} vč. DPH 12 %`, fontSize: 7, color: '#065F46AA', margin: [0, 0, 0, 4] },
                {
                  columns: [
                    { text: '', width: '*' },
                    { text: '− ' + fmt(TICKET_REVENUE), fontSize: 14, bold: true, color: '#059669', alignment: 'right', width: 'auto', margin: [0, 0, 16, 8] },
                  ],
                },
              ],
              border: [false, false, false, false],
              fillColor: '#10B98115',
              margin: [10, 0, 0, 0],
            },
          ]],
        },
        layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingTop: () => 0, paddingBottom: () => 0, paddingLeft: () => 0, paddingRight: () => 0 },
        margin: [0, 8, 0, 0],
      },
      // Sleva — finální obchodní (amber)
      {
        table: {
          widths: [3, '*'],
          body: [[
            { canvas: [{ type: 'rect', x: 0, y: 0, w: 3, h: 56, color: C.amber }], border: [false, false, false, false], fillColor: C.paper },
            {
              stack: [
                { text: 'FINÁLNÍ OBCHODNÍ SLEVA', fontSize: 8, color: C.accent, bold: true, characterSpacing: 1.5, margin: [0, 8, 0, 2] },
                { text: 'Kompletní zakázka — partnerský benefit při zachování kvality služeb', fontSize: 8, color: C.muted, margin: [0, 0, 0, 4] },
                {
                  columns: [
                    { text: '', width: '*' },
                    { text: '− ' + fmt(FINAL_DISCOUNT), fontSize: 14, bold: true, color: C.accent, alignment: 'right', width: 'auto', margin: [0, 0, 16, 8] },
                  ],
                },
              ],
              border: [false, false, false, false],
              fillColor: C.paper,
              margin: [10, 0, 0, 0],
            },
          ]],
        },
        layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingTop: () => 0, paddingBottom: () => 0, paddingLeft: () => 0, paddingRight: () => 0 },
        margin: [0, 6, 0, 0],
      },
      // Finální dark box s celkem
      {
        table: {
          widths: ['*', 'auto'],
          body: [
            [
              { text: 'CELKEM BEZ DPH', fontSize: 9, color: '#A8A69E', characterSpacing: 2, margin: [16, 14, 0, 4], border: [false, false, false, false], fillColor: C.ink },
              { text: fmt(TOTAL_NO_VAT), fontSize: 18, bold: true, color: C.white, alignment: 'right', margin: [0, 12, 16, 4], border: [false, false, false, false], fillColor: C.ink },
            ],
            [
              { text: 'DPH 21 % (orientačně)', fontSize: 8, color: '#A8A69E', characterSpacing: 1, margin: [16, 0, 0, 8], border: [false, false, false, false], fillColor: C.ink },
              { text: '+ ' + fmt(TOTAL_NO_VAT * VAT_RATE), fontSize: 9, color: '#A8A69E', alignment: 'right', margin: [0, 0, 16, 8], border: [false, false, false, false], fillColor: C.ink },
            ],
            [
              { text: 'CELKEM S DPH', fontSize: 10, bold: true, color: C.amber, characterSpacing: 2, margin: [16, 12, 0, 16], border: [false, true, false, false], borderColor: ['#FFFFFF22', '#FFFFFF22', '#FFFFFF22', '#FFFFFF22'], fillColor: C.ink },
              { text: fmt(TOTAL_WITH_VAT), fontSize: 22, bold: true, color: C.amber, alignment: 'right', margin: [0, 8, 16, 14], border: [false, true, false, false], borderColor: ['#FFFFFF22', '#FFFFFF22', '#FFFFFF22', '#FFFFFF22'], fillColor: C.ink },
            ],
          ],
        },
        layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingTop: () => 0, paddingBottom: () => 0 },
        margin: [0, 10, 0, 12],
      },
      {
        table: {
          widths: ['*'],
          body: [[{
            text: `Cena na osobu (bez DPH, kapacita ${GUEST_COUNT} osob)   ·   ` + fmt(TOTAL_NO_VAT / GUEST_COUNT),
            fontSize: 9,
            color: C.ink2,
            italics: true,
            margin: [12, 8, 12, 8],
            fillColor: C.paper,
            border: [false, false, false, false],
          }]],
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 16],
      },

      // ---------- R Reference ----------
      ...sectionHeader('R', 'Reference', { pageBreak: 'before' }),
      para('Výběr nedávných referencí relevantních pro typ a kapacitu akce Barum Czech Rally Zlín — konferenční formáty, sportovní eventy s VIP servisem a firemní galavečery pro nadnárodní korporáty.'),
      ...REFERENCES.map((r) => refCard(r)),

      // ---------- 15 Partnerství ----------
      ...sectionHeader('15', 'Návrh dlouhodobé spolupráce 2026 – 2028', { pageBreak: 'before' }),
      para('Nabídku koncipujeme jako základ pro tříletou rámcovou spolupráci na ročnících 2026, 2027 a 2028. Tříletý horizont umožňuje:'),
      bulletList([
        'Postupné rozšiřování VIP / hospitality kapacity a programu',
        'Fixaci nákupních cen mobiliáře a TOI TOI proti inflaci',
        'Jednotnou vizuální linku napříč ročníky (brandbook Continental)',
        'Reportování návštěvnosti a efektivity gastro zón po každém ročníku',
        'Možnost vyjednat exkluzivitu vůči konkurenčním brand zónám rally',
      ]),
      simpleTable([
        ['2026', 'Pilotní ročník — VIP / hospitality zóna 900 osob'],
        ['2027', 'Rozšíření o doprovodný program a brandové instalace'],
        ['2028', 'Plně integrovaná hospitality platforma napříč třídenní rally'],
      ], ['auto', '*']),

      // ---------- 16 Závěr ----------
      ...sectionHeader('16', 'Závěr'),
      para('Předkládaná nabídka představuje kompletní technicko-organizační řešení VIP a hospitality zóny pro Barum Czech Rally Zlín 2026 ve standardu odpovídajícím požadavkům značky Continental. Veškeré položky jsou podloženy reálnými dodavatelskými cenami pro daný rozsah akce.'),
      para('Po předběžném odsouhlasení rozsahu jsme připraveni dohodnout společnou obhlídku, finalizovat zónování plochy a podepsat smlouvu o dílo. V případě tříletého rámce nabízíme indexovanou cenu se zafixovanou hladinou klíčových položek.'),

      // ---------- Kontakt — dark card ----------
      {
        table: {
          widths: ['*'],
          body: [
            [{
              stack: [
                { text: 'KONTAKT DODAVATELE', fontSize: 8, color: C.amber, characterSpacing: 3, margin: [0, 0, 0, 8] },
                { text: META.supplier.name, fontSize: 16, bold: true, color: C.white, margin: [0, 0, 0, 4] },
                { canvas: [{ type: 'rect', x: 0, y: 0, w: 40, h: 1.5, color: C.amber }], margin: [0, 0, 0, 10] },
                {
                  columns: [
                    { stack: [
                      { text: 'KONTAKT', fontSize: 7, color: C.amber, characterSpacing: 1.5, margin: [0, 0, 0, 3] },
                      { text: META.supplier.contact.split(',')[0], fontSize: 10, bold: true, color: C.white },
                      { text: 'jednatel', fontSize: 9, color: '#A8A69E', margin: [0, 1, 0, 0] },
                    ] },
                    { stack: [
                      { text: 'TELEFON', fontSize: 7, color: C.amber, characterSpacing: 1.5, margin: [0, 0, 0, 3] },
                      { text: META.supplier.phone, fontSize: 10, bold: true, color: C.white },
                    ] },
                    { stack: [
                      { text: 'E-MAIL', fontSize: 7, color: C.amber, characterSpacing: 1.5, margin: [0, 0, 0, 3] },
                      { text: META.supplier.email, fontSize: 10, bold: true, color: C.white },
                    ] },
                  ],
                  columnGap: 16,
                  margin: [0, 0, 0, 14],
                },
                { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 480, y2: 0, lineWidth: 0.5, lineColor: '#FFFFFF22' }], margin: [0, 4, 0, 10] },
                { text: `IČO ${META.supplier.ico}  ·  DIČ ${META.supplier.dic}  ·  ${META.supplier.address}`, fontSize: 8.5, color: '#A8A69E' },
              ],
              fillColor: C.ink,
              border: [false, false, false, false],
              margin: [22, 22, 22, 22],
            }],
          ],
        },
        layout: 'noBorders',
        margin: [0, 18, 0, 0],
      },
    ],
    defaultStyle: { fontSize: 10, color: C.ink },
    styles: {},
  };
};

// ---------- Page ----------
const BarumOfferPage = () => {
  const handleDownloadPDF = () => {
    try {
      pdfMake.createPdf(buildPdf()).download('Nabidka_Barum_Rally_Zlin_2026.pdf');
    } catch (e) {
      console.error('PDF error:', e);
      alert('Nepodařilo se vygenerovat PDF. Zkuste to prosím znovu.');
    }
  };

  return (
    <div style={{ background: COLORS.bg, color: COLORS.ink, fontFamily: "'Inter', system-ui, sans-serif" }} data-testid="barum-offer-page">
      <Hero />
      <SectionIntro />
      <SectionUnderstanding />
      <SectionScope />
      <SectionLogistics />
      <SectionSchedule />
      <SectionTechnical />
      <SectionCatering />
      <SectionMobiliar />
      <SectionToiToi />
      <SectionSecurity />
      <SectionPersonnel />
      <SectionCleaning />
      <SectionEntrances />
      <SectionPricing handleDownloadPDF={handleDownloadPDF} />
      <SectionReferences />
      <SectionPartnership />
      <SectionConclusion />
      <footer className="py-10 text-center text-xs" style={{ background: COLORS.ink, color: '#A8A69E', fontFamily: 'ui-monospace, monospace' }}>
        BCR/2026/HOSP-21 — Vše pro akci — Otrokovice — 2026
      </footer>
    </div>
  );
};

export default BarumOfferPage;
